export default __webpack_public_path__ + "static/media/myc_pools_short.290fe0b1.svg";